import Table from "@/shared/components/Table";
import { COMMON_BUTTONS } from "@/config/actionButtonConfigs";
import ActionButtons from "@/shared/components/ActionButtons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function PaidLeaveApp() {
    const [selectedRecord, setSelectedRecord] = useState(null);
    const { t } = useTranslation();
    
    const columns = [
        { key: 'number', label: t('staff.paidLeaveApp.table.headers.number') },
        { key: 'date', label: t('staff.paidLeaveApp.table.headers.date') },
        { key: 'fromDate', label: t('staff.paidLeaveApp.table.headers.fromDate') },
        { key: 'deputy', label: t('staff.paidLeaveApp.table.headers.deputy') },
        { key: 'supervisor', label: t('staff.paidLeaveApp.table.headers.supervisor') },
        { key: 'manager', label: t('staff.paidLeaveApp.table.headers.manager') },
        { key: 'hr', label: t('staff.paidLeaveApp.table.headers.hr') },

    ]

    const data = [
        { number: 1, date: '2026-01-01', fromDate: '2026-01-01', deputy: 'John Doe', supervisor: 'Jane Doe', manager: 'Jim Doe', hr: 'Jill Doe' },
        { number: 2, date: '2026-01-02', fromDate: '2026-01-02', deputy: 'John Doe', supervisor: 'Jane Doe', manager: 'Jim Doe', hr: 'Jill Doe' },
        { number: 3, date: '2026-01-03', fromDate: '2026-01-03', deputy: 'John Doe', supervisor: 'Jane Doe', manager: 'Jim Doe', hr: 'Jill Doe' },
    ];

    const actionButtons = (
        <ActionButtons
            buttons={[
                {
                    ...COMMON_BUTTONS.ADD,
                    onClick: () => handleOpenModal('add')
                },
                {
                    ...COMMON_BUTTONS.EDIT,
                    onClick: () => handleOpenModal('edit')
                },
                {
                    ...COMMON_BUTTONS.DELETE,
                    onClick: () => handleOpenModal('delete')
                },
                {
                    ...COMMON_BUTTONS.PDF,
                    onClick: () => handleOpenModal('pdf')
                }
            ]}
            selectedRecord={selectedRecord}
        />
    );

    return (
        <Table
            title={t('staff.paidLeaveApp.title')}
            columns={columns}
            data={data}
            showPageSizeSelector={false}
            actionButtons={actionButtons}
        />
    );
}